import axios from 'axios'
import { AppConfiguration } from "read-appsettings-json";

class DataAccess{
    static post = async(props,callback) =>{
        let result = []
        await axios.post(AppConfiguration.Setting().noserapiendpoint + props.uri,  props.params)
        .then(res => {
            const data = res.data;
            callback({
                status:"1",
                code:data.code,
                message:data.message,
                data:data.status==="1" ? data : [],

                isloading: false,
                isshow: true,
                fade: true,
                alerttype: data.status==="1" ? "Success!" : "Error!",
                color: data.status==="1" ? "success" : "danger"
            })
            result = data
        })
        .catch(error=>{
            callback({
                status:"0",
                code:"",
                message:"An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                data:[],

                isloading: false,
                isshow: true,
                fade: true,
                alerttype: "Error!",
                color: "danger"
            })
        })
        return result
    }
}
export default DataAccess;
const GetRequest = async(props) => {
    let response = {
        "status" : "",
        "message" : "",
        [props.params._collection]:[]
    }
    let collection = new Array()
    await axios
      .post(props.url , props.params)
      .then(res => {
            const data = res.data
            data[props.params._collection].map(function(itm,i){
                let strJson = "{" + "'id':" + itm.substring(17, 43) + "," + itm.substring(46, itm.length)
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                collection.push(json)
            })
            response = {
                status : "1",
                "message" : "success",
                [props.params._collection]:collection
            }
      })
      .catch(error=>{
        response = {
            status : "0",
            "message" : "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
            [props.params._collection]:[]
        }
      })
    return response
} 
const PostRequest = async(props) => {
    let response = {
        "status" : "",
        "message" : ""
    }
    let collection = new Array()
    await axios
      .post(props.uri , props.params)
      .then(res => {
            //const data = res.data
            response = {
                status : "1",
                "message" : "success"
            }
      })
      .catch(error=>{
        response = {
            status : "0",
            "message" : "An error occured while processing your request, Please contact your System Administrator for : " + error.message
        }
      })
    return response
} 

// export { GetRequest, PostRequest }